<div class="toolbelt-container">
  <sysque-switch-with-label-v
    class="mt-2"
    [label]="'Processing Enabled'"
    [value]="processingEnabled"
    (onProcessToggleChange)="onProcessToggleChange($event)"
  ></sysque-switch-with-label-v>

  <sysque-switch-with-label-v
    [style.pointer-events]="processingEnabled ? 'auto' : 'none'"
    [label]="'Process Fittings Only'"
    [value]="processFittings"
    (onProcessToggleChange)="onProcessToggleChange($event)"
  ></sysque-switch-with-label-v>

  <sysque-switch-with-label-v
    [style.pointer-events]="processingEnabled ? 'auto' : 'none'"
    [label]="'Show Non Standard'"
    (onProcessToggleChange)="onProcessToggleChange($event)"
    [value]="showNonStandard"
  ></sysque-switch-with-label-v>

  <sysque-shift-segment (emitShiftValue)="emitShiftValue($event)"></sysque-shift-segment>

  <sysque-rotate-element
    [emitRotationValueChanged]="emitRotationValueChanged"
    [emitRotationAction]="emitRotationAction"
  ></sysque-rotate-element>

  <div class="list-container" [style.pointer-events]="processingEnabled ? 'auto' : 'none'">
    <div class="flex flex-row accordion" id="toolBeltAccordion">
      @for (data of toolItems; track data; let i = $index) {
        <div class="card">
          <div
            class="card-header cursor-pointer"
            role="button"
            id="accordionHeading{{ i }}"
            data-toggle="collapse"
            [attr.data-target]="'#codeCollapse' + i"
            [attr.aria-controls]="'codeCollapse' + i"
            [attr.aria-expanded]="i === 0 ? true : false"
          >
            <div style="float: left">
              <img src="assets/img/{{ data.keyIcon }}" style="width: 15px; margin-right: 12px" />
            </div>
            <h6 class="mb-0" id="collapsible-group-item-{{ i }}">
              {{ data.key }}
            </h6>
          </div>
          <div
            [id]="'codeCollapse' + i"
            class="collapse"
            [attr.data-parent]="'#toolBeltAccordion'"
            [ngClass]="{ show: i === 0 }"
          >
            <ul class="list-group">
              @for (item of data.items; track item) {
                <li
                  class="list-group-item list-item-left-control pl-0"
                  [ngClass]="{
                    disable: isItemDisabled(item),
                    'toolbelt-menu-item': !isItemDisabled(item),
                    selected: item.isSelected,
                  }"
                  (click)="showSysquePopup(item, $event.currentTarget)"
                >
                  <div style="margin: 0 5px 0 5px">
                    <img src="assets/img/{{ item.itemIcon }}" style="object-fit: fill; width: 25px" />
                  </div>
                  <div class="item-label">{{ item.itemName }}</div>
                  <!-- Nested item list -->
                  @if (selectedItem && selectedItem === item) {
                    <div
                      class="position-fixed pop-up-menu"
                      (mouseleave)="onFocusOut($event)"
                      [ngStyle]="{ 'top.px': popUpYPosition }"
                      [ngClass]="{ 'reporting-popup-menu': isReportingDialog }"
                    >
                      <ul class="list-group" tabindex="0">
                        @for (nestedItem of selectedItem.items; track nestedItem) {
                          <li
                            class="list-group-item list-item-left-control pl-0"
                            [ngClass]="{ disable: nestedItem.disabled, 'toolbelt-menu-item': !nestedItem.disabled }"
                            (click)="showSysquePopup(nestedItem, $event.currentTarget)"
                            tabindex="0"
                          >
                            <div style="margin: 0 5px 0 5px" tabindex="0">
                              <img
                                src="assets/img/{{ nestedItem.itemIcon }}"
                                style="object-fit: fill; width: 25px"
                                tabindex="0"
                                alt="toolbelt menu icon"
                              />
                            </div>
                            <div class="item-label" tabindex="0">{{ nestedItem.itemName }}</div>
                          </li>
                        }
                      </ul>
                    </div>
                  }
                  <!-- End of nested item list -->
                </li>
              }
            </ul>
          </div>
        </div>
      }
    </div>
  </div>
</div>
